import { isEmpty } from 'lodash/fp';
import { QueryState } from 'app/lib/constants';

export const isDatasetLoaded = (dataset, metadata) =>
    !isEmpty(dataset) && dataset.columns.length !== 0 && metadata.state !== QueryState.RUNNING;
